import React from 'react'

import Icon from '@/components/common/Icon'

const IconTwitter: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 32 33"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g clipPath="url(#clip0_279_1396)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5ZM14.038 17.3493L7.24283 8.26392H12.48L16.9348 14.2201L22.4481 8.26392H23.9872L17.6224 15.1398L24.8 24.7361H19.5628L14.7259 18.2687L8.73908 24.7361H7.2L14.038 17.3493ZM11.912 9.39744H9.50611L20.1305 23.6026H22.5364L11.912 9.39744Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_279_1396">
        <rect y="0.5" width="32" height="32" rx="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export default Icon(IconTwitter)
